
export const XopowoPad = props => {
  //console.log(props)
  const accessKey = props.accesKey
  return (
  <div className="pad pointerHover" id={props.id} onClick={props.handleClick} data-id="pad" title={accessKey} onGotPointerCapture={props.handlePointer} >
    <img draggable="false" className="pad-img pad-up visible noContextMenu" src={props.imgSrc[17]} alt="padUp" />
    <img draggable="false" className="pad-img pad-down hidden noContextMenu" src={props.imgSrc[18]} alt="padDown" />
  </div>
  )
}